export const ADDED_VERIFICATIONS = "ADDED_VERIFICATIONS";
export const VERIFICATION_ENTITY = "VERIFICATION_ENTITY";
export const VERIFICATIONS_TO_LAUNCH = "VERIFICATIONS_TO_LAUNCH";

export const INTERNAL_VERIFICATIONS = "INTERNAL_VERIFICATIONS";
export const INTERNAL_VERIFICATIONS_ON_PAGE = "INTERNAL_VERIFICATIONS_ON_PAGE";

export const PAGER = "PAGER";
export const TOTAL_COUNT = "TOTAL_COUNT";
export const FILTER = "FILTER";

export const CURRENT_ENTITIES = "CURRENT_ENTITIES";
